<div class="ai-datatable-overlay" *ngIf="busy()">
    <div class="ai-datatable-list-loading"></div>
</div>

<div class="ai-datatable" [ngStyle]="{ display: total() > 0 && !busy() }">
    <table>
        <thead>
            <tr>
                <th
                    *ngFor="let column of columns"
                    [ngStyle]="{ width: column.width() || 'auto' }"
                    [class.ai-datatable-hide-mobile]="column.hideOnMobile()"
                >
                    <ng-template #defaultHeaderTemplate>
                        <div
                            style="display: flex; gap: 8px; align-items: center"
                        >
                            <span>{{ column.title() }}</span>
                            <span class="sort-icons" *ngIf="column.sortable()">
                                <ai-icon
                                    [fontIcon]="'fa-solid fa-angle-up fa-sm'"
                                    [styleClass]="
                                        column.sortingDirection() == 'asc'
                                            ? 'ai-is-active'
                                            : ''
                                    "
                                    (click)="onClickSortColumn(column, 'asc')"
                                />

                                <ai-icon
                                    [fontIcon]="'fa-solid fa-angle-down fa-sm'"
                                    [styleClass]="
                                        column.sortingDirection() == 'desc'
                                            ? 'ai-is-active'
                                            : ''
                                    "
                                    (click)="onClickSortColumn(column, 'desc')"
                                />
                            </span>
                        </div>
                    </ng-template>

                    <ng-container
                        *ngTemplateOutlet="
                            column.headerTemplate || defaultHeaderTemplate;
                            context: { $implicit: column }
                        "
                    />
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows()" (click)="rowClick.emit(row.data)">
                <td
                    *ngFor="let cell of row.cells"
                    [class.ai-datatable-hide-mobile]="cell.hideOnMobile"
                >
                    <ng-template #defaultCellTemplate>{{
                        cell.value
                    }}</ng-template>
                    <ng-container
                        *ngTemplateOutlet="
                            cell.template || defaultCellTemplate;
                            context: { $implicit: row.data }
                        "
                    />
                </td>
            </tr>

            <!-- Linha fixa opcional ao final (ex.: linha de adição inline) -->
            <tr *ngIf="footerRowTemplate">
                <ng-container *ngTemplateOutlet="footerRowTemplate" />
            </tr>
        </tbody>
        <tfoot>
            @if (showPaginator() && total() > 0) {
                <tr>
                    <td colspan="100%">
                        <ai-paginator
                            [total]="total()"
                            [pageSize]="effectivePageSize()"
                            [pageSizeOptions]="pageSizeOptions()"
                            [(currentPage)]="currentPage"
                            (pageChanged)="onPageChanged($event)"
                            (pageSizeChanged)="onPageSizeChanged($event)"
                        />
                    </td>
                </tr>
            }
        </tfoot>
    </table>
</div>

<!-- Template padrão para exibir uma mensagem quando não há dados -->
<ng-template #defaultNoDataTemplate class="ai-datatable-no-data">
    <div class="ai-datatable-no-data">
        <div class="ai-row">
            <div class="no-results">
                <ai-icon [fontIcon]="'fa-solid fa-triangle-exclamation'" />
                <span>Nenhum dado para exibir.</span>
            </div>
        </div>
    </div>
</ng-template>

<div class="ai-datatable-no-data" *ngIf="total() <= 0 && !busy()">
    <ng-container
        *ngTemplateOutlet="noDataTemplate || defaultNoDataTemplate"
    ></ng-container>
</div>
